<script>
import { authComputed } from '@state/helpers'
import formatProductType from '@utils/format-product-type'
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
    pageType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isModalLoginActive: false,
      loginCallBack: null,
    }
  },
  computed: {
    ...authComputed,
    newebpayCallBack() {
      const callbackData = window.globalData.newebpay;

      return (
        callbackData &&
        callbackData.status !== '{{$status}}'
        && {
          isSuccess: callbackData.status === 'SUCCESS',
          isExpired: callbackData.status === 'EXPIRED',
          message: callbackData.message || '',
        }
      )
    },
    orderProductType() {
      if(this.pageType === 'prepaid') {
        return 'prepaid'
      }else {
        return this.order.productType || 'activity'
      }
    },
  },
  methods: {
    formatProductType,
    reloadPage() {
      this.$router.go(0)
    },
    toOrder(orderId, hasData = true) {
      if(!this.loggedIn) {
        this.isModalLoginActive = true;
        this.loginCallBack = () => {
          this.toOrder(orderId, hasData)
        };
        return false;
      }

      window.globalData.order = hasData ? {
        status: 'SUCCESS',
        type: 'deduct'
      } : false;

      this.reloadPage();
      /* if(hasData) {
        this.reloadPage();
      }else {
        this.$router.push({
          name: this.pageType === 'prepaid' ? 'prepaid-order-detail' : 'order-detail',
          params: {
            orderKey: orderId
          },
          query: {
            o: this.$route.query.o ? undefined : orderId,
            language: this.$route.query.language,
          }
        })
      } */
    },
  },
}
</script>
<template>
  <div class="booking-container has-text-centered">
    <template >
      <div class="booking-section">
        <div class="subsection">
          <!--成功-->
          <template v-if="newebpayCallBack.isSuccess">
            <img
              v-if="formatProductType('category', order.productType) === 'activity'"
              alt="結帳成功" :class="$style.image" src="~@assets/images/admission_connect.png" />
            <img
              v-if="formatProductType('category', order.productType) === 'light'"
              alt="結帳成功" :class="$style.image" src="~@assets/images/accept_notice.png" />
            <h1 class="has-text-primary is-size-3">{{ $t('global.CALLBACK_SUCCESS_TITLE'/*登記成功*/) }}</h1>
            <p
              v-if="formatProductType('category', order.productType) === 'activity'">
              {{ $t('global.CALLBACK_PRODUCT_CONTENT'/*感謝您的結緣！您的登記已完成。我們已寄發憑證至使用人的電子郵件*/) }}
            </p>
            <p
              v-if="formatProductType('category', order.productType) === 'light'">
              {{ $t('global.CALLBACK_LIGHT_CONTENT'/*感謝您的結緣！您的登記已完成。待廟方人員完成安奉作業後即可查看您的燈*/) }}
            </p>
            <br>
            <br><br>
            <b-button
              type="is-primary"
              rounded
              class="is-fullwidth"
              @click="toOrder($route.params.orderKey, false)"
            >
              {{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
              <span v-if="!loggedIn">
                ({{ $t('global.NEED_LOGIN'/*需驗證*/) }})
              </span>
            </b-button>
          </template>

          <!--過期-->
          <template v-else-if="newebpayCallBack.isExpired">
            <img alt="結帳失敗" :class="$style.image" src="~@assets/images/3d_expired.png" />
            <h1 class="has-text-primary is-size-3">{{ $t('global.CALLBACK_EXPIRED_TITLE'/*逾時結帳，付款未成功*/) }}</h1>
            <p>{{ $t('global.CALLBACK_EXPIRED_CONTENT'/*親愛的客戶，您的結緣已逾時，造成結帳未成功，請您重新再試。提醒您，請在15分鐘內完成結帳，以免逾時*/) }}</p>
          </template>

          <!--失敗-->
          <template v-else>
            <img alt="" :class="$style.image" src="~@assets/images/3d_failed.png" />
            <h1 class="has-text-primary is-size-3">{{ $t('global.CALLBACK_FAILED_TITLE'/*結帳失敗*/) }}</h1>
            <p>{{ newebpayCallBack.message }}</p>
          </template>
        </div>
      </div>
    </template>
    <b-modal
      custom-class="is-login-style"
      :active.sync="isModalLoginActive"
      :width="370"
      :can-cancel="['escape','outside']"
    >
      <ModalLogin @close="isModalLoginActive = false" @login="loginCallBack" />
    </b-modal>
  </div>
</template>
<style lang="scss" module>
  .image {
    align-self: center;
    margin: 2rem 0;
  }
</style>
